export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_teutonic-app-1/artifacts/zvtt69k9_Bildschirmfoto%202026-06-08%20um%2020.59.06.png";

export const BRAND = {
  name: "Rosenberg Objektservice",
  short: "Rosenberg",
  region: "Südhessen",
  tagline: "Ihr Makler, der mit anpackt.",
  email: "info@rosenberg-objektservice.de",
  phone: "0155 62376061",
  phoneIntl: "+4915562376061",
  address: "Weserstraße 3, 63322 Rödermark",
  owner: "Marc Rosenberg",
};

export const NAV_LINKS = [
  { label: "Philosophie", href: "#philosophie" },
  { label: "Leistungen", href: "#leistungen" },
  { label: "Werte", href: "#werte" },
  { label: "Kontakt", href: "#kontakt" },
];

export const ANLIEGEN = [
  { value: "vermittlung", label: "Immobilienvermittlung (Kauf / Verkauf / Vermietung)" },
  { value: "besichtigung_verkaufshilfe", label: "Besichtigungen & Verkaufsunterstützung" },
  { value: "instandhaltung_reparatur", label: "Instandhaltung & kleine Reparaturen" },
  { value: "pflege_garten", label: "Pflege & Gartenarbeit" },
  { value: "objektbetreuung", label: "Objektbetreuung" },
  { value: "persoenliche_begleitung", label: "Persönliche Begleitung" },
  { value: "sonstiges", label: "Sonstiges" },
];
